import { CountryCode, RegisterApiOptions, RegisterStatus } from '../../shared/models/register';
import EnrouteApiClient from '../../shared/services/enroute-api-client';
import { mapAxiosResponse} from "../../shared/utils/api-utils";
import { ServerError, ServerErrorMessages } from "../../shared/utils/server-error-utils";

const FLOW_TYPE = 'code_online';

const getRefIdByCountry = (country: CountryCode) => {
  switch(country) {
    case CountryCode.EU: 
      return process.env.ORGANIZATION_SIGNUP_REFERRER_ID_S1;  
    case CountryCode.restOfWorld: 
      return process.env.ORGANIZATION_SIGNUP_REFERRER_ID_S0_REST;  
    case CountryCode.US:
    default:
      return process.env.ORGANIZATION_SIGNUP_REFERRER_ID;  
  }
}

export default class RegisterService {

  public static async register(options: RegisterApiOptions): Promise<RegisterStatus | Error> {
    return EnrouteApiClient.post('/account/signup', {
      flow: FLOW_TYPE,
      referrer_org_id: parseInt(getRefIdByCountry(options.shard as CountryCode)!, 10),
      org: {
        name: options.name,
        info: {
          industry: options.info.industry,
          num_employees: options.info.num_employees,
          referrer: options.info.referrer,
          country: options.shard,
        }
      },
      agent: {
        name: options.agent.name,
        email: options.agent.email,
        username: options.agent.email,
        password: options.agent.password,
        info: {
          job_title: options.info.job_title,
          phones: [
            {
              type: 'cell',
              number: options.agent.phone,
            },
          ],
        },
      },
    })
      .then(resp => mapAxiosResponse<RegisterStatus>(resp))
      .catch(error => {
        let errorMessage = ServerErrorMessages[error.message];
        if (!errorMessage) {
          errorMessage = ServerErrorMessages[ServerError.UnexpectedError];
        }

        throw new Error(errorMessage);
      });
  }
}